<template>
  <div v-if="permission.is_readonly && got_feature('feature_download_docs_file_ro')">
    <v-btn
        class="mt-1"
        color="primary"
        @click="downloadDocument()"
        outlined
        fab
        small
      >
        <v-icon v-once>mdi-download</v-icon>
      </v-btn>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "ShowDownloadDocBtn",
  props: {
  },
  data() {
    return {
    };
  },
  components: {
  },
  computed:{
    ...mapGetters('documents',['currentDocument']),
    ...mapGetters({
      permission: 'permissions/permission',
      got_feature: 'got_feature',
    }),
  },
  methods: {
    ...mapActions({
      downloadFile:"documents/downloadFile",
    }),
    downloadDocument() {
      let filename = 'doc_'+this.currentDocument.id.toString();
      if (this.currentDocument.originalFileName) {
        filename += '_'+this.currentDocument.originalFileName;
      }
      else if (this.currentDocument.supplierName) {
        filename += '_'+this.currentDocument.supplierName.replace(' ','_');
      }
      else if(this.currentDocument.customerName) {
        filename += '_'+this.currentDocument.customerName.replace(' ','_');
      }
      if (!filename.endsWith('.pdf') && !filename.endsWith('.PDF')) {
        filename+='.pdf'
      }
      this.downloadFile({"signed_url":this.currentDocument.signed_url,"filename":filename});
    },
  },
};
</script>

